import yup from 'utils/yup';

export const validationSchema = yup.object().shape({
  title: yup.string().trim().required(),
  primaryColor: yup.string().nullable().hex(),
  partnerAgentId: yup
    .number()
    .nullable()
    .when('whiteLabelingOn', {
      is: true,
      then: yup.number().nullable().required('Please, choose a partner'),
    }),
});

export const tourRequestValidationSchema = validationSchema.shape({
  tourRequest: yup.object().shape({
    id: yup.string().required(),
  }),
});
